/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useMemo, useState } from "react";
import { useCountries } from "../lib/react-query/useCountries";
import { useCountryStates } from "../lib/react-query/useCountryStates";

const useCountriesAndStates = (enabled) => {
  const [selectedCountryId, setSelectedCountryId] = useState(false);
  const [countryHasStates, setCountryHasStates] = useState(false);

  const { data: countries, isLoading } = useCountries({ enabled });
  const { data: states } = useCountryStates(selectedCountryId, {
    enabled: countryHasStates,
  });

  const formattedCountriesOptions = useMemo(
    () =>
      countries?.map((country) => ({
        value: country.id,
        label: country.name,
        hasStates: country.has_states,
      })) || [],
    [countries]
  );

  const formattedStatesOptions = useMemo(
    () =>
      states?.map((state) => ({
        value: state.id,
        label: state.name,
      })) || [],
    [states]
  );

  const handleCountryChange = (e) => {
    const countryId = e.target.value;
    const selectedCountry = countries.find((country) => country.id === countryId);

    setSelectedCountryId(countryId);
    setCountryHasStates(selectedCountry?.has_states);
  };

  return {
    formattedCountriesOptions,
    formattedStatesOptions,
    handleCountryChange,
    isLoading,
    countryHasStates,
  };
};

export default useCountriesAndStates;
